import { render } from "./NewBusinessPage.vue?vue&type=template&id=c68e48fc&scoped=true&ts=true"
import script from "./NewBusinessPage.vue?vue&type=script&lang=ts"
export * from "./NewBusinessPage.vue?vue&type=script&lang=ts"

import "./NewBusinessPage.vue?vue&type=style&index=0&id=c68e48fc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c68e48fc"]])

export default __exports__